import { Route, Routes } from "react-router-dom";

import ConfirmPage from "./pages/Confirm";
import Home from "./pages/Home";
import LoginPage from "./pages/Login";
import Reports from "./pages/Reports";
import ResetPage from "./pages/Reset";
import Upload from "./pages/Upload";

function App() {
    return (
        <>
            <div className="container">
                <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/reset" element={<ResetPage />} />
                    <Route path="/confirm" element={<ConfirmPage />} />
                    <Route path="/home" element={<Home />}>
                        <Route path="" element={<Reports />} />
                        <Route path="reports" element={<Reports />} />
                        <Route path="upload" element={<Upload />} />
                    </Route>
                </Routes>
            </div>
        </>
    );
}

export default App;
